import { FDA } from "@/data/content";

export const ClaimNote = ({ light = false, className = "", testId = "claim-disclaimer" }) => (
  <p data-testid={testId} className={`mt-6 rounded-xl border-2 px-4 py-3 text-xs leading-relaxed ${light ? "border-cream/40 text-cream/80" : "border-navy/30 bg-white/60 text-slate-600"} ${className}`}>*{FDA}</p>
);

export const Warnings = ({ text, title = "Warnings", testId = "warnings-block" }) => (
  <div data-testid={testId} className="sticker-sm bg-white p-5">
    <p className="font-display uppercase text-lg">{title}</p>
    <p className="mt-2 text-sm text-slate-700 leading-relaxed">{text}</p>
  </div>
);

export const Wave = ({ fill = "#F6EFE3", flip = false, className = "" }) => (
  <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className={`block w-full h-10 sm:h-16 ${flip ? "rotate-180" : ""} ${className}`} aria-hidden="true">
    <path fill={fill} d="M0,40 C120,80 240,0 360,40 C480,80 600,0 720,40 C840,80 960,0 1080,40 C1200,80 1320,0 1440,40 L1440,80 L0,80 Z" />
  </svg>
);

export const SectionTitle = ({ chip, title, sub, light = false, testId, as: H = "h2" }) => (
  <div className="max-w-2xl" data-testid={testId}>
    {chip && <span className={`label-chip ${light ? "bg-sand text-navy" : "bg-white"}`}>{chip}</span>}
    <H className={`mt-4 text-3xl sm:text-4xl lg:text-5xl uppercase leading-[0.95] ${light ? "text-cream" : "text-navy"}`}>{title}</H>
    {sub && <p className={`mt-4 text-base md:text-lg ${light ? "text-cream/80" : "text-slate-600"}`}>{sub}</p>}
  </div>
);
